import { createContext, useContext, useEffect } from "react";

/**
 * Global theme provider — LOCKED TO LIGHT.
 *
 * The SRES workspace and marketing site are strictly light-themed to keep
 * a single, professional visual identity end-to-end. This provider exists
 * only to keep the existing `useTheme()` import surface stable across the
 * codebase; it no longer supports switching or persistence.
 */
const ThemeContext = createContext({ theme: "light", setTheme: () => {}, toggle: () => {} });

export function ThemeProvider({ children }) {
  // On mount, forcibly clear any legacy dark preference and lock the root
  // element to light. This runs on every reload so previously persisted
  // dark-mode users are migrated silently.
  useEffect(() => {
    const root = document.documentElement;
    root.classList.remove("dark");
    root.style.colorScheme = "light";
    try {
      window.localStorage.removeItem("sres-theme");
    } catch { /* ignore */ }
  }, []);

  const value = { theme: "light", setTheme: () => {}, toggle: () => {} };
  return (
    <ThemeContext.Provider value={value}>{children}</ThemeContext.Provider>
  );
}

export function useTheme() {
  return useContext(ThemeContext);
}
